module.exports = __webpack_public_path__ + "img/温度监测.dc054fad.png";